<template>
  <div class="change-log container">
    <h1 class="text-center header">
      <i18n path="common.changeLog" />
    </h1>
    <section
      v-for="(cl, index) in changeLogs"
      :key="index"
      class="mb-5"
    >
      <h3 class="px-3 d-flex align-items-end">
        <span>v{{ cl.version }}</span>
        <small class="ms-auto text-muted">{{ cl.time }}</small>
      </h3>
      <hr class="mt-0 mb-4 bg-secondary bg-opacity-75">
      <p
        v-for="(log, logIndex) in cl.changes"
        :key="logIndex"
        v-html="log"
      />
    </section>
  </div>
</template>

<script>
// import { getProjectByKey } from '@/store/urls'
import '@/styles/changelog.scss'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      changeLogs: []
    }
  },
  computed: {
    ...mapState(['language', 'changeLog'])
  },
  watch: {
    language () {
      this.loadChangeLog()
    }
  },
  methods: {
    loadChangeLog () {
      const project = this.$route.params.project
      if (project && this.language && this.changeLog) {
        this.changeLogs = this.changeLog[project][this.language]
      }
    }
  },
  beforeMount () {
    this.loadChangeLog()
  }
}
</script>
